"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Link as ScrollLink } from "react-scroll";

const ContactButton = ({ className }: { className?: string }) => {
  const pathname = usePathname();

  if (pathname !== "/") {
    return (
      <Link href="/#GetInTouch" className={`nav-link ${className}`}>
        Contact
      </Link>
    );
  }

  return (
    <ScrollLink
      to="GetInTouch"
      smooth={true}
      className={`nav-link ${className}`}
    >
      Contact
    </ScrollLink>
  );
};

export default ContactButton;
